/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type OrganizationBasicDetailsFragment = {
  isSolo: boolean | null;
  name: string | null;
  organizationId: string | null;
  squareLogo: string | null;
  horizontalLogo: string | null;
  timeZone: string | null;
  isVatPayer: boolean | null;
};

export type UpdateOrganizationMutationVariables = Exact<{
  organizationUpdate: Types.OrganizationUpdate;
  organizationId: string;
}>;

export type UpdateOrganizationMutation = {
  updateOrganization: {
    isSolo: boolean | null;
    name: string | null;
    organizationId: string | null;
    squareLogo: string | null;
    horizontalLogo: string | null;
    timeZone: string | null;
    isVatPayer: boolean | null;
  } | null;
};

export type GetOrganizationBasicDetailsQueryVariables = Exact<{
  organizationId: string;
}>;

export type GetOrganizationBasicDetailsQuery = {
  getOrganizationConfigDetails: {
    isSolo: boolean | null;
    name: string | null;
    organizationId: string | null;
    squareLogo: string | null;
    horizontalLogo: string | null;
    timeZone: string | null;
    isVatPayer: boolean | null;
  } | null;
};

export const OrganizationBasicDetailsFragmentDoc = gql`
  fragment OrganizationBasicDetails on OrganizationConfigDetails {
    isSolo
    name
    organizationId
    squareLogo
    horizontalLogo
    timeZone
    isVatPayer
  }
`;
export const UpdateOrganizationDocument = gql`
  mutation updateOrganization(
    $organizationUpdate: OrganizationUpdate!
    $organizationId: ID!
  ) {
    updateOrganization(
      update: $organizationUpdate
      organizationId: $organizationId
    ) {
      ...OrganizationBasicDetails
    }
  }
  ${OrganizationBasicDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateOrganizationGQL extends Apollo.Mutation<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
> {
  document = UpdateOrganizationDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetOrganizationBasicDetailsDocument = gql`
  query getOrganizationBasicDetails($organizationId: ID!) {
    getOrganizationConfigDetails(organizationId: $organizationId) {
      ...OrganizationBasicDetails
    }
  }
  ${OrganizationBasicDetailsFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetOrganizationBasicDetailsGQL extends Apollo.Query<
  GetOrganizationBasicDetailsQuery,
  GetOrganizationBasicDetailsQueryVariables
> {
  document = GetOrganizationBasicDetailsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
